<template>
<div style="background:#fff">
    <div class="pageContainer">
        <img src="@/views/solution/images/top.png" alt="" srcset="" style="width:100%;">

    </div>
    <div class="containerOne" style="position:relative;width:100%;padding:0 0 80px 0;margin:45px 0 0 0">
      <div style="width:1300px;margin:0 auto">
        <!-- <img src="@/views/solution/images/group02.png" alt="" srcset="" style="width:100%;padding:30px 0 0px 0;display:block;margin-bottom:20px;"> -->
        <!-- 公共组建开始 -->
        <module-tit title="Solution" subTitle="解决方案"/>
        <!-- 公共组件结束 -->
        <div v-html="contentObj.content"></div>
        <!-- <div style="margin:0 0 20px 0">
          <span style="font-weight:300;padding:0 20px 0 0;font-size:28px">HEALTH IN SPORTS</span><span style="font-weight:700;font-size:24px;">体育健康</span>
        </div>
        
        <div class="one" style="position:relative;margin: 0 0 20px 0">
          <img src="@/views/solutionDetail/images/item01.png" alt="" srcset="" style="width:480px;position:absolute;right:0;top:-60px;z-index:1">
          <div class="footWords">
            <div class="tit">
              <span style="font-size:20px;font-weight:700">户外体育健身器材系列</span>
              <span style="font-size:36px;font-weight:700">专属行业定制 持续赋能行业</span>
            </div>
            
            <span style="padding:30px 10px 0 0;display:block;font-size:14px;letter-spacing:2px">高档商用健身器材方面，满足客户对于亮光、亚光、无光、纹理等多品种的需求，采用了高品质的表面效果及诸多金属闪光、珠光等特殊效果产品，丰富了色彩种类，并根据国际体育器材展会流行趋势及自身研发，为客户提供更多色彩搭配方案。</span>
          </div>
        </div>
         <div class="one" style="position:relative">
          <img src="@/views/solutionDetail/images/item02.png" alt="" srcset="" style="width:360px;position:absolute;left:0;top:60px;z-index:1">
          <div class="footWords" style="position:absolute;right:0;bottom:-400px">
            <div class="tit">
              <span style="font-size:20px;font-weight:700;text-align:right">户外健身路径系列</span>
              <span style="font-size:36px;font-weight:700;text-align:right">超强耐候耐光属性 适应各种环境</span>
            </div>
            
            <span style="padding:30px 10px 0 0;display:block;font-size:14px;letter-spacing:2px">采用耐候、耐光优越，机械性能优异的原材料，无论是高温高湿的沿海，还是光照强烈的高原，我们都可提供客户工业级、建材级、超耐侯级等不同耐候要求的产品，同时根据客户底材的处理需求，为客户提供了富锌底粉功能性产品，大大提高了客户基材的稳定性。</span>
          </div>
        </div> -->
        <div class="clearBoth"></div>
      </div>
    </div>
    <!-- <footerComponent/> -->
</div>
</template>
<script>

import moduleTit from '@/components/moduleTit'
import { getRead } from '@/api/index.js'
export default {
  name: 'App',
   components:{
    moduleTit
  },
  data() {  
    return {  
      contentObj:{}
    };  
  }, 
  mounted() {
    this.initEvent()
  },
  methods:{
    initEvent() {
      this.$nextTick(()=>{
        let _id = this.$route.query.id
        let _obj = {id:_id}
            getRead(_obj).then((res)=>{
              this.contentObj = res.data
            })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.containerOne{
  .one{
    width:100%
  }
}
.footWords{
  padding:20px 0;
  line-height: 30px;
  width:55%;
}
.clearBoth {
  clear:both
}
.footWords{
  .tit {
    border-bottom: 1px solid red;
    padding:0 0 30px 0;
    span{
      display: block;
      padding:12px 0;
    }
  }
}
</style>
